import { legacyColors } from '~/legacyTheme';
import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    dialogOverflow: {
      overflow: 'visible',
    },
    dialogOverflowUP: {
      overflow: 'auto',
    },
    selectStyle: {
      width: theme.spacing(35),
    },
    dialogContent: {
      padding: theme.spacing(1, 2),
      borderBottom: `solid 1px ${legacyColors.grey4}`,
    },
    rightDiv: {
      marginLeft: theme.spacing(),
    },
    dialogRoot: {
      height: theme.spacing(63),
      maxWidth: theme.spacing(76),
      minWidth: theme.spacing(76),
    },
    legacyInput: {
      padding: '3px 6px',
      border: '1px solid #ccc',
      borderRadius: '4px',
    },
    multiStyle: {
      '& .chosen-choices': {
        padding: '0px 5px',
        border: '1px solid #ccc',
        borderRadius: '4px',
      },
    },
    cssLabelDiv: {
      marginTop: '5px',
      fontSize: '13px',
      fontWeight: 'bold',
    },
    highlightColor: {
      color: '#05A4D8',
    },
    linkStyle: {
      '& i': {
        marginRight: '5px',
      },
      '& em': {
        fontStyle: 'normal ',
      },
    },
    error: {
      color: 'red',
      fontSize: '13px',
    },
    dateInput: {
      width: '105px',
    },
    linkHover: {
      '&:hover': {
        '& em': {
          borderBottom: '1px solid #05A4D8',
        },
      },
    },
    loadingMiddle: {
      position: 'absolute',
      left: '50%',
      right: '50%',
      top: '50%',
      bottom: '50%',
    },
    required: {
      width: '6px',
      height: '6px',
      background: '#d9534f',
      display: 'inline-block',
      margin: '4px 4px 0 4px',
      borderRadius: '3px',
    },
  };
};
